import * as React from 'react';
import { StyledInputElement, StyledInputRoot } from './NumberInput.styles';

export interface NumberInputProps {
  value?: number | null;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: number | null) => void;
}

export const NumberInput = React.forwardRef(function NumberInput(
  props: NumberInputProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { value, min, max, disabled, onChange } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    const raw = e.target.value;
    onChange(e, raw === '' ? null : Number(raw));
  };

  return (
    <StyledInputRoot ref={ref} className="numberInput">
      <StyledInputElement
        type="number"
        value={value ?? ''}
        min={min}
        max={max}
        disabled={disabled}
        onChange={handleChange}
      />
    </StyledInputRoot>
  );
});
